import React from 'react';
import styles from './index.module.scss';
import UnknownText from '../../text_components/unknown_text';
import UnknownLongText from '../../long_text_components/unknown_long_text';
import UnknownImg from '../../img_components/unknown_img';
import UnknownImgsBlock from '../../imgs_block_components/unknown_imgs_block';
import UnknownVideo from '../../video_components/unknown_video';

const UnknownBlock = ({ blockData, path_to_folder }) => {
  const renderContent = (content) => {
    if (content.cotent_type === 'text') {
      return (
        <UnknownText
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
        />
      );
    }
    if (content.cotent_type === 'long_text') {
      return (
        <UnknownLongText
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
        />
      );
    }
    if (content.cotent_type === 'img') {
      return (
        <UnknownImg
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
        />
      );
    }
    if (content.cotent_type === 'imgs_block') {
      return (
        <UnknownImgsBlock
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
        />
      );
    }
    if (content.cotent_type === 'video') {
      return (
        <UnknownVideo
          contentData={content}
          contentText={content.content_text}
          contentName={content.cotent_name}
          imgName={content.img_name}
          imgsNames={content.imgs_names}
          videoName={content.video_name}
          path_to_folder={path_to_folder}
        />
      );
    }
    return null;
  };

  return (
    <div className={styles.unknownBlock}>
      <h2 className={styles.title}>Неизвестный Блок</h2>
      <div className={styles.blockInfoContainer}>
        {(blockData?.boock_tag || blockData?.block_tag) && (
          <div className={styles.blockInfoItem}>
            <span className={styles.label}>Тег блока:</span>
            <span className={styles.value}>{blockData.boock_tag || blockData.block_tag}</span>
          </div>
        )}
        {(blockData?.boock_name || blockData?.block_name) && (
          <div className={styles.blockInfoItem}>
            <span className={styles.label}>Имя блока:</span>
            <span className={styles.value}>{blockData.boock_name || blockData.block_name}</span>
          </div>
        )}
      </div>
      <p className={styles.description}>Компонент для неизвестного блока</p>
      {blockData && blockData.block_content && Array.isArray(blockData.block_content) && (
        <div className={styles.contentContainer}>
          <h4>Контент блока:</h4>
          {blockData.block_content.map((content, index) => (
            <div key={index} className={styles.contentWrapper}>
              {renderContent(content)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UnknownBlock;
